import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  HStack,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import Search from './icons/Search';
import Sidebar from './Sidebar';
import { format } from 'date-fns';
import NotificationBell from './NotificationBell';

const CurrentTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Text noOfLines={1}>
      {format(currentDateTime, 'MMMM do, yyyy hh:mm aa')}
    </Text>
  );
};

const Header = () => {
  const sidebar = useDisclosure();

  return (
    <HStack
      as="header"
      align="center"
      justify="space-between"
      w="full"
      px="4"
      borderBottomWidth="1px"
      borderColor="lightGray.600"
      h="16"
    >
      <Drawer
        isOpen={sidebar.isOpen}
        onClose={sidebar.onClose}
        placement="left"
      >
        <DrawerOverlay />
        <DrawerContent>
          <Sidebar w="full" borderRight="none" />
        </DrawerContent>
      </Drawer>
      <IconButton
        aria-label="Menu"
        display={{
          base: 'inline-flex',
          md: 'none',
        }}
        onClick={sidebar.onOpen}
        icon={<FiMenu />}
        variant={'outline'}
        size="sm"
      />
      <InputGroup
        w="96"
        display={{
          md: 'flex',
        }}
        color={'black'}
      >
        <Input
          placeholder="Search"
          _placeholder={{ color: 'lightGray.500' }}
          color={'black'}
          variant="filled"
          bg={'white'}
          hidden
        />
        <InputRightElement
          children={
            <IconButton
              variant={'ghost'}
              icon={<Icon as={Search} color="lightGray.500" />}
            />
          }
          hidden
        />
      </InputGroup>
      <HStack spacing={4} align="center">
        <Box
          bg={'white'}
          px={4}
          py={3}
          rounded={'lg'}
          display={{
            base: 'none',
            md: 'unset',
          }}
        >
          <CurrentTime />
        </Box>
        <NotificationBell />
      </HStack>
    </HStack>
  );
};

export default Header;
